import React from "react";

// Find2Near logo — the "search + community + camera + map + message" collage.
// The PNG lives in /public so it's cache-friendly and served by the CDN.
//
// Accessibility · Phase 4A · the block name and the tagline used to be two
// sibling <div>s with no separator, which made screen readers (and scrapers)
// read the accessible name as "find2nearVocal · For · Local". We now wrap the
// text block in a single element carrying an explicit `aria-label` and put a
// visually-hidden separator between the two lines so any text-only extraction
// reads it as "Find2Near — Vocal for Local".
export default function Logo({ size = 36, showText = true, tagline = true, className = "" }) {
  const ACCESSIBLE = tagline ? "Find2Near — Vocal for Local" : "Find2Near";
  return (
    <div className={`flex items-center gap-2 ${className}`} role="img" aria-label={ACCESSIBLE}>
      <img
        src="/logo.png"
        alt=""                                        /* alt suppressed — the wrapper owns the accessible name */
        aria-hidden="true"
        width={size}
        height={size}
        className="shrink-0 rounded-full object-cover"
        style={{ width: size, height: size }}
      />
      {showText && (
        <div className="leading-none" aria-hidden="true">
          <div className="heading font-extrabold text-stone-900" style={{ fontSize: size * 0.5 }}>
            find2near
          </div>
          {tagline && (
            <>
              {/* Screen readers already have the aria-label above; sighted users
                   see the tagline as before. The `sr-only` span guarantees any
                   text-only DOM scrape still contains a natural separator. */}
              <span className="sr-only"> — </span>
              <div className="text-[9px] uppercase tracking-[0.22em] text-[#2D5A27] font-bold mt-0.5">
                Vocal · For · Local
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
